import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Alert
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import {
  add_subadmin,
  update_user,
  get_user_details
} from "../../../redux/actions/subAdminActions";
import { promote_salesPerson } from "../../../redux/actions/salesPersonActions";
import "../../../style/subAdmin/SubAdmin.scss";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import CountryStateCity from "../../../components/countryStateCity/CountryStateCity";
import {roleList} from '../../../redux/actions/siteActions';
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import loader from "../../../style/loader/loader.scss";
import Dialog from "react-bootstrap-dialog";
import NumberFormat from "react-number-format";
import DatePicker from "react-date-picker";
import moment from "moment";
import {
  getSiteCity
} from "../../../redux/actions/frontActions";
const history = createBrowserHistory();
let isvalid = 1,
  invalidphone = "",
  disabled = false,
  submitValue = "Save",
  isLoading = "false",
  userIdParams = "",
  domain = "",
  useremail = "",
  xCoordinate = {},
  yCoordinate = {};
class AddSubAdmin extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      path: ["Home", "Manage Employee", "Add New"],
      links:["home", "userList", "addSubAdmin"],
      id: "",
      userName: "",
      userNameError: "",
      email: "",
      emailError: "",
      firstName: "",
      firstNameError: "",
      lastName: "",
      lastNameError: "",
      dob: "",
      dobError: "",
      gender: "Male",
      genderError: "",
      phone: "",
      phoneError: "",
      address1: "",
      address1Error: "",
      address2: "",
      address2Error: "",
      cityID: "",
      cityIDError: "",
      city: "",
      state: "",
      country: "",
      addCity: "",
      countryError: "",
      addCityError: "",
      stateError: "",      
      cityError: "",
      zipcode: "",
      zipcodeError: "",
      status: "Active",
      alertMessage: "",
      msgType: "warning",
      countryName: "",
      stateAbbr: "",
      counter: 0,
      show: false,
      disabled: false,
      userTypeID: "",
      RuserTypeID: "",
      commission: "",
      roleList: [],
      cityList:[],
    };
    this.validate = this.validate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear = this.Clear.bind(this);
  }

  // onChangeStartDate = date => { this.setState({ dob: date})};
  onChangeStartDate = (selectedDate) => {
   
    if (selectedDate instanceof Date && !isNaN(selectedDate)) {
         this.setState({
           dob: selectedDate,
           dobError: false // Reset error state if a valid date is selected
         });
       } 
       else if(selectedDate  === null)
       {
        this.setState({
          dob: '',
          dobError: false // Reset error state if a valid date is selected
        });
       }
       else {
         // Handle invalid date (optional)
       //  console.error('Invalid date selected:', selectedDate);
      
         this.setState({
      
        dobError: true // Set error state to indicate invalid date
           
         });
    
       }
     };

  handleChange(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
    this.setState({ disabled: false });
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  componentWillUnmount() {
    this.props.clearAlert();
  }

  validate = () => {
    xCoordinate = {}
    yCoordinate = {}

    let isError = false;
    const errors = {};
    if (!this.state.userName || this.state.userName.length === 0) {
      isError = true;
      this.setState({ userNameError: "red" });
      if(xCoordinate.key !== 'formBasicUserNameText'){
        let x = window.scrollX + document.querySelector('#formBasicUserNameText').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formBasicUserNameText').getBoundingClientRect().top - 89
        xCoordinate['formBasicUserNameText'] = x;
        yCoordinate['formBasicUserNameText'] = y;
      }
    }
    if (!this.state.email || this.state.email.length === 0) {
      isError = true; 
      this.setState({ emailError: "red" });
      if(xCoordinate.key !== 'formBasicEmailText'){
        let x = window.scrollX + document.querySelector('#formBasicEmailText').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formBasicEmailText').getBoundingClientRect().top -89
        xCoordinate['formBasicEmailText'] = x;
        yCoordinate['formBasicEmailText'] = y;
      }
    } else if (this.state.email) {
      if (this.getValidationEmailState()) {
        isError = true;
        if(xCoordinate.key !== 'formBasicEmailText'){
        let x = window.scrollX + document.querySelector('#formBasicEmailText').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formBasicEmailText').getBoundingClientRect().top - 89
        xCoordinate['formBasicEmailText'] = x;
        yCoordinate['formBasicEmailText'] = y;
      }
      }
    }
    if (!this.state.firstName || this.state.firstName.length === 0) {
      isError = true;

      this.setState({ firstNameError: "red" });
      if(xCoordinate.key !== 'formBasicFirstNameText'){
        let x = window.scrollX + document.querySelector('#formBasicFirstNameText').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formBasicFirstNameText').getBoundingClientRect().top - 89
        xCoordinate['formBasicFirstNameText'] = x;
        yCoordinate['formBasicFirstNameText'] = y;
      }
    }
    if (!this.state.lastName || this.state.lastName.length === 0) {
      isError = true; 
      this.setState({ lastNameError: "red" });
      if(xCoordinate.key !== 'formBasicLastNameText'){
        let x = window.scrollX + document.querySelector('#formBasicLastNameText').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formBasicLastNameText').getBoundingClientRect().top - 89
        xCoordinate['formBasicLastNameText'] = x;
        yCoordinate['formBasicLastNameText'] = y;
      }
    }

    if (!this.state.address1 || this.state.address1.length === 0) {
      isError = true; 
      this.setState({ address1Error: "red" });
      if(xCoordinate.key !== 'formBasicAddressOneText'){
        let x = window.scrollX + document.querySelector('#formBasicAddressOneText').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formBasicAddressOneText').getBoundingClientRect().top - 89
        xCoordinate['formBasicAddressOneText'] = x;
        yCoordinate['formBasicAddressOneText'] = y;
      }
    }

    if (!this.state.country) {
      isError = true;
      this.setState({ countryError: "red" });
      if(xCoordinate.key !== 'formBasicCountryText'){
        let x = window.scrollX + document.querySelector('#formBasicCountryText').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formBasicCountryText').getBoundingClientRect().top - 89
        xCoordinate['formBasicCountryText'] = x;
        yCoordinate['formBasicCountryText'] = y;
      }
    }

    if (!this.state.state) {
      isError = true;
      this.setState({ stateError: "red" });
      if(xCoordinate.key !== 'formBasicStateText'){
        let x = window.scrollX + document.querySelector('#formBasicStateText').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formBasicStateText').getBoundingClientRect().top - 89
        xCoordinate['formBasicStateText'] = x;
        yCoordinate['formBasicStateText'] = y;
      }
    }
    if (!this.state.addCity) {
      isError = true;
      this.setState({ addCityError: "red" });
      if(xCoordinate.key !== 'formBasicaddCityText'){
        let x = window.scrollX + document.querySelector('#formBasicaddCityText').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formBasicaddCityText').getBoundingClientRect().top - 89
        xCoordinate['formBasicaddCityText'] = x;
        yCoordinate['formBasicaddCityText'] = y;
      }
    }
    if (!this.state.cityID) {
      isError = true;
      this.setState({ cityIDError: "red" });
      if(xCoordinate.key !== 'formControlsSelectCityType'){
        let x = window.scrollX + document.querySelector('#formControlsSelectCityType').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formControlsSelectCityType').getBoundingClientRect().top - 89
        xCoordinate['formControlsSelectCityType'] = x;
        yCoordinate['formControlsSelectCityType'] = y;
      }
    }
    if (this.state.phone) {
      if (this.getValidationState()) {
        isError = true;
        if(xCoordinate.key !== 'formBasicPhoneText'){
        let x = window.scrollX + document.querySelector('#formBasicPhoneText').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formBasicPhoneText').getBoundingClientRect().top - 89
        xCoordinate['formBasicPhoneText'] = x;
        yCoordinate['formBasicPhoneText'] = y;
      }
      }
    }
    if (!this.state.userTypeID) {
      isError = true;
      this.setState({ userTypeIDError: "red" });
      if(xCoordinate.key !== 'formControlsSelectType'){
        let x = window.scrollX + document.querySelector('#formControlsSelectType').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formControlsSelectType').getBoundingClientRect().top - 89
        xCoordinate['formControlsSelectType'] = x;
        yCoordinate['formControlsSelectType'] = y;
      }
    }
    if (!this.state.commission) {
        isError = true;
        this.setState({ commissionError: "red" });
        if(xCoordinate.key !== 'formBasicCommissionText'){
        let x = window.scrollX + document.querySelector('#formBasicCommissionText').getBoundingClientRect().left
        let y = window.scrollY + document.querySelector('#formBasicCommissionText').getBoundingClientRect().top - 89
        xCoordinate['formBasicCommissionText'] = x;
        yCoordinate['formBasicCommissionText'] = y;
      }
    }

    return isError;
  };

  getValidationEmailState() {
    if (this.state.email) {
      const length = this.state.email.length;
      if (length !== 0) {
        let emailpattern = new RegExp(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        if (!emailpattern.test(this.state.email)) {
          return "error";
        }
      }
    }

    return null;
  }

  handleSubmit(e) {
    e.preventDefault();
    const err = this.validate();
    this.handleDismiss();
    const date = this.state.dob ? moment(this.state.dob).format('YYYY-MM-DD') : null;
    if (!err) {
      this.setState({ disabled: true });
      this.handleShow();

      if (this.state.id !== "") {
        const updateData = {
          id: this.state.id,
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          email: this.state.email,
          dob: date,
          gender: this.state.gender,
          phone: this.state.phone,
          address1: this.state.address1,
          address2: this.state.address2,
          cityID: this.state.cityID,
          city: this.state.city,
          state: this.state.state,
          stateAbbr: this.state.stateAbbr,
          country: this.state.country,
          addCity: this.state.addCity,
          zipcode: this.state.zipcode,
          status: this.state.status,
          userTypeID: this.state.userTypeID,
          commission: this.state.commission
        };

        this.props.update_user(updateData);
      } else {
        const postData = {
          userName: this.state.userName,
          email: this.state.email,
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          dob: date,
          gender: this.state.gender,
          phone: this.state.phone,
          address1: this.state.address1,
          address2: this.state.address2,
          cityID: this.state.cityID,
          city: this.state.city,
          state: this.state.state,
          stateAbbr: this.state.stateAbbr,
          country: this.state.country,
          addCity: this.state.addCity,
          zipcode: this.state.zipcode ? this.state.zipcode : "",
          status: this.state.status,
          userTypeID: this.state.userTypeID,
          commission: this.state.commission
        };
        this.props.add_subadmin(postData);
      }
    }
    else{
      let arr = Object.values(yCoordinate)
      let min = Math.min(...arr);
      let yCoordinateKey= '',yCoordinateValue, xCoordinateValue
      {Object.keys(yCoordinate).map((key) => {
        if(yCoordinate[key] === min && yCoordinateKey.length == 0){
          yCoordinateValue = yCoordinate[key]
          yCoordinateKey = key
        }
      })}
      if(yCoordinateKey.length > 0){
        xCoordinateValue = xCoordinate[yCoordinateKey]
        window.scrollTo(xCoordinateValue,yCoordinateValue)
      }
    }
  }

  onSelectedCountry = (val, key) => {
    this.setState({ country: val });
    this.setState({ countryName: key });
    if(this.state.country != val){
      this.setState({state: '', stateAbbr: '', city: '', cityID: ''});
    }
    this.setState({ disabled: false });
  };

  onSelectedState = (val, key) => {
    this.setState({ state: key });
    this.setState({ stateAbbr: val });
    this.setState({ disabled: false });
  };

  onSelectedCity = (val, key) => {
    this.setState({ city: val });
    this.setState({ cityID: key });
    if (this.state.cityID.length === 0) {
      this.setState({ cityIDError: "" });
    }
    this.setState({ disabled: false });
  };

  componentWillMount() {
    this.props.clearAlert();
    this.handleDismiss();
    this.props.getSiteCity();

    userIdParams = this.props.match.params.userId
      ? this.props.match.params.userId
      : "";
    const editLink = this.props.match.params.userId && `addSubAdmin/${this.props.match.params.userId}`
    if (userIdParams !== "") {
      isLoading = true;
      this.props.get_user_details(userIdParams);
      this.state.path = ["Home", "Manage Employee", "Edit Details"];
      this.state.links = ["home", "userList", editLink]
    }
    this.props.roleList({page: 0, get_all:'yes'});
  }

  getValidationState() {
    if (this.state.phone) {
      const length = this.state.phone.length;
      if (length !== 0) {
        let mobilepattern = new RegExp(/^\d{3}-\d{3}-\d{4}$/i);
        if (!mobilepattern.test(this.state.phone)) {
          return "error";
        }
      }
    }

    return null;
  }

  Clear() {
    (this.state.userName = ""),
      (this.state.email = ""),
      (this.state.firstName = ""),
      (this.state.lastName = ""),
      (this.state.dob = ""),
      (this.state.gender = "Male"),
      (this.state.phone = ""),
      (this.state.address1 = ""),
      (this.state.address2 = ""),
      (this.state.city = ""),
      (this.state.country = ""),
      (this.state.addCity = ""),
      (this.state.cityID = ""),
      (this.state.state = ""),
      (this.state.zipcode = ""),
      (this.state.commission = ""),
      (this.state.userTypeID = ""),
      (this.state.status = "Active");
    disabled = false;
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);

        isLoading = "false";
        window.scrollTo(0, 0);
      }
    }

    if (this.props.role !== nextProps.role) {
      if (nextProps.role) {
        this.setState({
          roleList: nextProps.role.data,
        });
        isLoading = "false";
      }
    }

    if (this.props.subAdminResponse !== nextProps.subAdminResponse) {
      if (nextProps.subAdminResponse) {
        this.props.clearAlert();
        this.handleShow();
        this.onSelectedCountry();
        this.props.renderAlert("success", nextProps.subAdminResponse.message);
        this.setState({ disabled: false });
        isLoading = "false";
        this.Clear();
        window.scrollTo(0, 0);
        let userID = nextProps.subAdminResponse.data.user_id
          ? nextProps.subAdminResponse.data.user_id
          : "";
        if (this.state.RuserTypeID == "5" && userID !== "") {
          this.context.router.history.push(`/cities/permission/${userID}`);
        }
        this.Clear();
      }
    }

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }
    if (this.props.updatedUser !== nextProps.updatedUser) {
      if (nextProps.updatedUser) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.updatedUser.message);
        this.setState({ disabled: false });
        isLoading = "false";
        this.props.get_user_details(this.state.id);
        window.scrollTo(0, 0);
      }
    }

    if (this.props.salesPersonaccess !== nextProps.salesPersonaccess) {
      if (nextProps.salesPersonaccess) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.salesPersonaccess.message);
        this.setState({ disabled: false });
        isLoading = "false";
        this.props.get_user_details(this.state.id);
      }
    }

    if (this.props.userDetails !== nextProps.userDetails) {
      if (nextProps.userDetails) {
        this.setState({ userDetailsForEdit: nextProps.userDetails.data });
        let user = nextProps.userDetails.data;
        if (user) {
          isLoading = false;
        }
        this.setState({
          id: user.user_id,
          address1: user.address1,
          address2: user.address2,
          city: user.city,
          cityID: user.cityID,
          country: user.country,
          addCity: user.addCity,
          dob: (user.dob) ? new Date(moment(user.dob).format('YYYY-MM-DD')) : "",
          email: user.email,
          firstName: user.firstName,
          gender: user.gender,
          lastName: user.lastName,
          phone: user.phone,
          state: user.state,
          stateAbbr: user.stateAbbr,
          status: user.status,
          userName: user.userName,
          zipcode: user.zipcode,
          userTypeID: user.userTypeID,
          RuserTypeID: user.userTypeID,
          commission: user.commission
        });
        if (user.userTypeID == "4") {
          domain = user.siteDomain.split("@");
          useremail = user.email.split("@");
        }
      }
    }
    if(this.props.cityList != nextProps.cityList){
      if(nextProps.cityList){
        this.setState({cityList: nextProps.cityList.data});
      }
    }
  }

  handlePromote(e) {
    e.preventDefault();
    const postData = {
      userID: this.state.id
    };
    this.props.promote_salesPerson(postData);
  }

  render() {
    return (
      <div className="col-lg-12 add-sub-admin">
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <div className="row">
          {this.state.show &&
            this.state.alertMessage !== "" && (
              <div className="col-lg-12">
                <Alert
                  bsStyle={this.state.msgType}
                  onDismiss={this.handleDismiss}
                >
                  <strong>{this.state.msgType}:</strong>{" "}
                  {this.state.alertMessage}
                </Alert>
              </div>
            )}
          <div className="col-xs-12">
            <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
          </div>
        </div>

        <div className="panel">
          <header className="panel-heading">{this.state.RuserTypeID != '' ? 'Edit' : 'Add'} Employee</header>
    
          <div className="panel-body">
            <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <Row>
                <form onSubmit={this.handleSubmit}>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formBasicUserNameText">
                      <ControlLabel>
                        {" "}
                        <span style={{ color: "red" }}>*</span> User Name
                      </ControlLabel>
                      <FormControl
                        type="text"
                        name="userName"
                        value={this.state.userName}
                        placeholder="Enter User Name"
                        onChange={this.handleChange}
                        disabled={this.state.id === "" ? false : true}
                        style={{ borderColor: this.state.userNameError }}
                      />
                    </FormGroup>
                    <ControlLabel>
                      <span style={{ color: "red" }}>*</span> Email
                    </ControlLabel>
                    <FormGroup
                      controlId="formBasicEmailText"
                      validationState={this.getValidationEmailState()}
                    >
                      <FormControl
                        type="email"
                        value={this.state.email}
                        placeholder="Enter email"
                        onChange={this.handleChange}
                        name="email"
                        disabled={false}
                        style={{ borderColor: this.state.emailError }}
                      />
                    </FormGroup>
                    <FormGroup controlId="formBasicFirstNameText">
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> First Name
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.firstName}
                        placeholder="Enter First Name"
                        onChange={this.handleChange}
                        name="firstName"
                        style={{ borderColor: this.state.firstNameError }}
                      />
                    </FormGroup>
                    <FormGroup controlId="formBasicLastNameText">
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> Last Name
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.lastName}
                        placeholder="Enter Last Name"
                        onChange={this.handleChange}
                        name="lastName"
                        style={{ borderColor: this.state.lastNameError }}
                      />
                    </FormGroup>
                    <FormGroup controlId="formBasicDOBText">
                      <ControlLabel>Date Of Birth</ControlLabel><br/>
                      {/*<FormControl
                                              type="date"
                                              value={this.state.dob}
                                              placeholder="MM-DD-YYYY"
                                              onChange={this.handleChange}
                                              name="dob"
                                            />*/}
                      <DatePicker
                        onChange={this.onChangeStartDate}
                        value={this.state.dob}
                      />
                    </FormGroup>
                    <FormGroup controlId="formControlsSelect">
                      <ControlLabel>Gender</ControlLabel>
                      <FormControl
                        componentClass="select"
                        placeholder="Gender"
                        name="gender"
                        value={this.state.gender}
                        onChange={this.handleChange}
                      >
                        <option value="Male">Male</option>
                        <option value="Female"> Female </option>
                      </FormControl>
                    </FormGroup>
                    <ControlLabel>Phone (format: xxx-xxx-xxxx)</ControlLabel>
                    <FormGroup
                      controlId="formBasicPhoneText"
                      validationState={this.getValidationState()}
                    >
                      <NumberFormat
                        format="###-###-####"
                        mask="_"
                        className="form-control"
                        name="phone"
                        placeholder="Enter Phone Number"
                        value={this.state.phone}
                        onChange={this.handleChange}
                        style={{ borderColor: this.state.phoneError }}
                      />
                    </FormGroup>
                    {(!this.state.RuserTypeID || [1, 2, 3, 4, 6].includes(this.state.RuserTypeID) == false) ? (
                    <FormGroup controlId="formControlsSelectType">
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> User Type
                      </ControlLabel>
                      <FormControl
                        componentClass="select"
                        name="userTypeID"
                        style={{ borderColor: this.state.userTypeIDError }}
                        value={this.state.userTypeID}
                        onChange={this.handleChange}
                      >
                        <option value="">Select Type</option>
                        {(this.state.roleList) && this.state.RuserTypeID!=8 ?
                            this.state.roleList.map((role, index) =>
                              <option value={role.userTypeID}>{role.userTypeLabel}</option>
                            )
                          :
                            (
                              <React.Fragment>
                                <option value="4">Customer</option>
                                <option value="8">Guest User</option>
                              </React.Fragment>
                            )
                        }
                      </FormControl>
                    </FormGroup>): ("")}
                    <FormGroup controlId="formBasicCommissionText">
                      <ControlLabel>
                        {" "}
                        <span style={{ color: "red" }}>*</span> Employee Commission
                      </ControlLabel>
                      <FormControl
                        type="text"
                        name="commission"
                        value={this.state.commission}
                        placeholder="Enter Employee Commission"
                        onChange={this.handleChange}
                        style={{ borderColor: this.state.commissionError }}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formBasicAddressOneText">
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> Address1
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.address1}
                        placeholder="Enter Address"
                        onChange={this.handleChange}
                        name="address1"
                        style={{ borderColor: this.state.address1Error }}
                      />
                    </FormGroup>
                    <FormGroup controlId="formBasicAddressTwoText">
                      <ControlLabel>Address2</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.address2}
                        placeholder="Enter Address"
                        onChange={this.handleChange}
                        name="address2"
                      />
                    </FormGroup>
                    <FormGroup controlId="formBasicCountryText">
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> Country
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={(this.state.country) ? this.state.country : ''}
                        placeholder="Country"
                        onChange={this.handleChange}
                        name="country"
                        style={{ borderColor: this.state.countryError }}
                        autoComplete="off"
                      />
                    </FormGroup>
                    <FormGroup controlId="formBasicStateText">
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> State/Province
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={(this.state.state) ? this.state.state : ''}
                        placeholder="State"
                        onChange={this.handleChange}
                        name="state"
                        style={{ borderColor: this.state.stateError }}
                        autoComplete="off"
                      />
                    </FormGroup>
                    <FormGroup controlId="formBasicaddCityText">
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> Add City
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={(this.state.addCity) ? this.state.addCity : ''}
                        placeholder="Add City"
                        onChange={this.handleChange}
                        name="addCity"
                        style={{ borderColor: this.state.addCityError }}
                        autoComplete="off"
                      />
                    </FormGroup>
                    <FormGroup controlId="formControlsSelectCityType">
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> Subscriber City
                      </ControlLabel>
                      <FormControl
                        componentClass="select"
                        name="cityID"
                        style={{borderColor:this.state.cityIDError}}
                        value={this.state.cityID}
                        placeholder="select"
                        onChange={this.handleChange}
                      >
                        <option value="">Choose Region</option>
                        {(this.state.cityList) &&
                              this.state.cityList.map((data, index) =>
                                <optgroup key={'hcity'+index} label={data.country}>
                                  {(data.cities) &&
                                    data.cities.map((city, index) => 
                                      <option key={'hcityval'+index} value={city.cityID}>{city.title}</option>
                                    )
                                  }
                                </optgroup>
                              )
                        }
                    </FormControl>
                    </FormGroup> 
                    <FormGroup controlId="formBasicZipText">
                      <ControlLabel>Zipcode</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.zipcode}
                        placeholder="Enter Zipcode"
                        onChange={this.handleChange}
                        name="zipcode"
                      />
                    </FormGroup>
                    <FormGroup controlId="formControlsStatusSelect">
                      <ControlLabel>Status</ControlLabel>
                      <FormControl
                        componentClass="select"
                        placeholder="select"
                        name="status"
                        value={this.state.status}
                        onChange={this.handleChange}
                      >
                        <option value="Active">Active</option>
                        <option value="Inactive"> Inactive </option>
                      </FormControl>
                    </FormGroup>                    
                  </Col>

                  <Row className="BtnRow">
                    {this.props.match.params.userId &&
                    <Col md={2} xs={2}>
                      <Button bsStyle="info" type="button" onClick={() => this.context.router.history.push(`/admin/resetPassword/${this.state.id}`)}>Manually Set Password</Button>
                    </Col>
                    }
                    <Col md={10} xs={10} className="pull-right">
                      {this.state.RuserTypeID == "4" &&
                      domain[1] == useremail[1] ? (
                        <Button
                          bsStyle="success"
                          onClick={this.handlePromote.bind(this)}
                        >
                          Promote to Sales Person
                        </Button>
                      ) : (
                        ""
                      )}
                      <Button
                        bsStyle="info"
                        type="submit"
                        id="saveButton"
                        disabled={this.state.disabled}
                      >
                        Save
                      </Button>
                      <Button
                        bsStyle="default"
                        onClick={() => this.context.router.history.push(`/userList`)}
                      >
                        Cancel
                      </Button>
                    </Col>
                  </Row>
                </form>
              </Row>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AddSubAdmin.propTypes = {
  add_subadmin: PropTypes.func.isRequired,
  get_user_details: PropTypes.func.isRequired,
  update_user: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  subAdminResponse: state.subAdminReducer.subAdminResponse,
  userDetails: state.subAdminReducer.userDetails,
  error: state.subAdminReducer.error,
  updatedUser: state.subAdminReducer.updatedUser,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message,
  salesPersonaccess: state.salesPersonReducer.salesPersonaccess,
  cityList: state.frontReducer.cityList,
  role: state.siteReducer.role,
});
export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, {
    add_subadmin,
    update_user,
    get_user_details,
    renderAlert,
    clearAlert,
    promote_salesPerson,
    getSiteCity,
    roleList
  })
)(AddSubAdmin);



// WEBPACK FOOTER //
// ./src/app/views/admin/subAdmin/AddSubAdmin.js